const GROUPS = {
  LEVEL1_AUDIT: 'UG_001000000022469', // 一级审核组
  LEVEL2_AUDIT: 'UG_001000000021647', // 二级审核组
  CONTENT_MODIFY: 'UG_001000000020640', // 内容修改确认组
  ADMIN: 'UG_001000000019117', // 管理员组
  UPLOAD: 'UG_001000000026419' // 内容上传人组
}

export { GROUPS }
